const CalendarMode = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
  RANGE: 'range',
}

export default CalendarMode
